import { POST_ID } from '../../routes/Variables';

/**
 * Obtém a URL do blog a partir da URL atual
 * @returns {string} URL do blog
 */
export const getUrlBlog = () => {
  return window.location.href.split('/wp-admin')[0];
};

/**
 * Verifica se o artigo está sendo gerado ou editado por IA
 * @returns {boolean} True se gerado por IA, false caso contrário
 */
export const verificarGeradorIa = () => {
  const currentUrl = window.location.href;
  return currentUrl.includes('criar-artigo=true') || currentUrl.includes('editar-artigo');
};

/**
 * Obtém o ID do post atual
 * @returns {number} ID do post
 */
export const obterIdPost = () => {
  const idPost =
    typeof POST_ID !== 'undefined' && POST_ID !== '0'
      ? POST_ID
      : localStorage.getItem('id_artigo_ia') ?? '0';

  return parseInt(idPost);
};

/**
 * Formata um payload para salvar um artigo
 * @param {Object} params - Parâmetros para o payload
 * @returns {Object} Payload formatado
 */
export const formatarPayloadArtigo = ({
  idPost,
  usuario,
  urlBlog,
  dataPublicacao,
  foiGeradoPorIa,
}) => {
  if (!usuario?.data || !dataPublicacao) return null;

  return {
    idArtigoWp: idPost,
    idUsuarioWordpress: parseInt(usuario.data.idUsuarioWordpress),
    idUsuario: parseInt(usuario.data.idUsuarioOpti),
    url: urlBlog,
    dataPublicacao,
    geradoPorIa: foiGeradoPorIa,
  };
};
